import "./Engineering.css";
import Header from "../../components/Header";
import work from "../../assets/work2.jpg";
import project from "../../assets/project.jpg";
import certificate from "../../assets/me3.jpeg";
import sum1 from "../../assets/about-asteroid-main.png";
import sum2 from "../../assets/about-asteroid1.png";
import sum3 from "../../assets/about-asteroid2.png";
import university from "../../assets/university.png";
import { Parallax } from "react-scroll-parallax";
import Footer from "../../components/Footer";

function Engineering() {
  function notification() {
    new Notification("Harry Azamosa Portfolio", {
      body: `The curriculum vitae of Harry Azamosa Osawayemen has been downloaded to your local device storage`,
    });
  }

  return (
    <div className="engineering">
      <Header />
      <div className="engineering_body">
        <section className="engineering_section_one">
          <div className="engineering_section_one_hero">
            <h1>Research Computational Engineer | Graduate Student</h1>
          </div>
        </section>
        {/* <section className="engineering_section_summary">
          <Parallax
            scale={[1, 0.25]}
            rotate={[10, -180]}
            speed={-30}
            easing="easeInQuad"
          >
            <img alt="" src={sum2} className="sum2" />
          </Parallax>
          <Parallax speed={-15}>
            <img alt="" src={sum1} className="sum1" />
          </Parallax>
          <Parallax speed={-5}>
            <img alt="" src={sum3} className="sum3" />
          </Parallax>
          <Parallax speed={10}>
            <img alt="" src={sum3} className="sum4" />
          </Parallax>
          <div className="section_summary">
            <h3>
              We are here <b style={{ color: "#2e1d06" }}>somewhere</b>
            </h3>
            <h1>Engineering beyond boundaries</h1>
            <p>
              Engineering, to me, is a way of understanding the laws that govern
              nature— from fluid motion and heat transfer to the technologies
              that power our future.
            </p>
            <br />
            <p>
              I am a Mechanical Engineer with a passion for computational
              science, thermal-fluid systems, and nuclear engineering. After
              earning my B.Eng. from the University of Benin, I completed a
              Master's in Mechanical Engineering at the University of Lagos and
              am currently pursuing a Master's in Nuclear Engineering at IMT
              Atlantique, France. My research combines Computational Fluid
              Dynamics (CFD), thermal-hydraulics, scientific computing, and
              software development to solve complex engineering problems, with a
              growing focus on advanced reactor systems and scientific
              instrumentation.
            </p>
          </div>
        </section> */}
        <section className="engineering_section_two">
          <div>
            {/* <h1>Professional Journey so far</h1> */}
            <hr id="first_rule" />
            <h2>EDUCATION</h2>
            <hr />
            <div className="engineering_section_two_div">
              <h3>2025 - Present</h3>
              <div>
                <h4>Masters in Nuclear Engineering</h4>
                <p>IMT Atlantique</p>
              </div>
              <h3>Nantes, France</h3>
            </div>
            <hr />
            <div className="engineering_section_two_div">
              <h3>2024 - 2025</h3>
              <div>
                <h4>Masters in Mechanical Engineering (Thermofluid)</h4>
                <p>University of Lagos</p>
              </div>
              <h3>Lagos State, Nigeria</h3>
            </div>
            <hr />
            <div className="engineering_section_two_div">
              <h3>2016 - 2022</h3>
              <div>
                <h4>Bachelors of Engineering honors (Mechanical)</h4>
                <p>University of Benin, Benin City</p>
              </div>
              <h3>Benin City, Nigeria</h3>
            </div>
            <hr />
            {/* <div className="engineering_section_two_div">
              <h3>2007 - 2013</h3>
              <div>
                <h4>Secondary school leaving certificate</h4>
                <p>School of Secondary Education, I.C.E.</p>
              </div>
              <h3>Warri City, Nigeria</h3>
            </div> */}
          </div>
          <img alt="" src={university} className="engineering_section_image" />
        </section>
        <section className="engineering_section_three">
          <div>
            <hr id="first_rule" />
            <h2>WORK EXPERIENCE</h2>
            <hr />
            <div className="engineering_section_three_div">
              <h3>October 2024 - July 2025</h3>
              <div>
                <h4>Research Assistant</h4>
                <p>University of Lagos</p>
              </div>
              <h3>Lagos State</h3>
            </div>
            <hr />
            <div className="engineering_section_three_div">
              <h3>August 2023 - July 2024</h3>
              <div>
                <h4>NYSC Graduate engineering trainee</h4>
                <p>Chibufavor Automobile Nigeria</p>
              </div>
              <h3>Umuahia, Abia state</h3>
            </div>
            <hr />
            <div className="engineering_section_three_div">
              <h3>January 2022 - November 2022</h3>
              <div>
                <h4>CATIA contract worker</h4>
                <p>University of West Scotland</p>
              </div>
              <h3>Remote</h3>
            </div>
            <hr />
            <div className="engineering_section_three_div">
              <h3>April 2021 - September 2021</h3>
              <div>
                <h4>SIWES Internship</h4>
                <p>NNPC - Chevron JV</p>
              </div>
              <h3>Benin City, Nigeria</h3>
            </div>
            <hr />
            <div className="engineering_section_three_div">
              <h3>UBITS Internship</h3>
              <div>
                <h4>Lab technician</h4>
                <p>Department of Mechanical Engineering, University of Benin</p>
              </div>
              <h3>Benin City, Nigeria</h3>
            </div>
            <hr />
          </div>
          <img alt="" src={work} className="engineering_section_image" />
        </section>
        <section className="engineering_section_two">
          <div>
            <hr id="first_rule" />
            <h2>PROJECTS</h2>
            <hr />
            <div className="engineering_section_two_div">
              <h3>Department of mechanical engineering, University of Benin</h3>
              <div>
                <p>
                  Design and fabrication of an economic waste plastic grinder
                </p>
              </div>
              <h3>Benin City, Nigeria</h3>
            </div>
            <hr />
            <div className="engineering_section_two_div">
              <h3>NIPES Engineering journal | Research Gate</h3>
              <div>
                <p>Design and fabrication of a mini fire fighting robot</p>
              </div>
              <h3>Online Journal</h3>
            </div>
          </div>
          <img alt="" src={project} className="engineering_section_image" />
        </section>
        <section className="engineering_section_three">
          <div>
            <hr id="first_rule" />
            <h2>CERTIFICATIONS AND MEMBERSHIPS</h2>
            <hr />
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Member</h4>
                <p>The Nigerian Society of Engineers (NSE)</p>
              </div>
              <div>
                <h4>Corperate member</h4>
                <p>
                  Nigerian Institution of Professional Engineers and Scientists
                  (NIPES)
                </p>
              </div>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Member</h4>
                <p>International Association of Engineers (IAENG)</p>
              </div>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Member</h4>
                <p>Institute of Mechanical Engineers (IMechE)</p>
              </div>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Affiliate member</h4>
                <p>Nigerian Institute of Mechanical Engineers (NIMechE)</p>
              </div>
            </div>
            <hr />
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Quality assurance and quality control certification</h4>
                <p>Our Growth International</p>
              </div>
              <h3>issued: December 2023</h3>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Certified project management professional</h4>
                <p>Gold Seal Certification IGO</p>
              </div>
              <h3>issued: October 2023</h3>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>
                  WSO Occupational and enviromental safety and health (HSE level
                  1,2 and 3) certifications
                </h4>
                <p>World Safety Organization ( WSO )</p>
              </div>
              <h3>issued: October 2023</h3>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Human Resource Mangement Certification</h4>
                <p>Britist Certification Inc.</p>
              </div>
              <h3>issued: October 2023</h3>
            </div>
            <div className="engineering_section_three_divvv">
              <div>
                <h4>Enviromental Impact Asssesment</h4>
                <p>
                  Enviromental Impact Asssesment Experts' Certification Scheme
                </p>
              </div>
              <h3>issued: October 2023</h3>
            </div>
          </div>
          <img alt="" src={certificate} className="engineering_section_image" />
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Engineering;
